gsap.registerPlugin(ScrollTrigger);

const cards = document.querySelectorAll(".startWhere_card, .continue_exploring_card, .IntendedAudience_card");

cards.forEach((card) => {

  const bg = document.createElement("div");
  bg.classList.add("bg-fill");
  card.prepend(bg);

  const textElements = card.querySelectorAll("h6, p, h5, a");

  // Initial state
  gsap.set(textElements, { opacity: 0, x: -30 });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: card,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });

  tl.to(bg, {
    scaleX: 1,
    duration: 0.8,
    ease: "power3.out"
  });

  tl.to(textElements, {
    opacity: 1,
    x: 0,
    duration: 0.6,
    stagger: 0.15,
    ease: "power3.out",
    clearProps: "transform"
  }, "-=0.4");

});




const cardsW = document.querySelectorAll(".WhatGuides_card");

cardsW.forEach((card) => {

  // Create background layer
  const bgw = document.createElement("div");
  bgw.classList.add("bg-fill");
  card.prepend(bgw);

  const tl1 = gsap.timeline({
    scrollTrigger: {
      trigger: card,
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });

  // Background left → right
  tl1.to(bgw, {
    scaleX: 1,
    duration: 0.8,
    ease: "power3.out"
  });

  // Text left → right
  tl1.to(card.querySelectorAll("h6, p"), {
    opacity: 1,
    x: 0,
    duration: 0.6,
    stagger: 0.15,
    ease: "power3.out"
  }, "-=0.4");

});